import Form from "../components/Form"
import Heroimg2 from "../components/Heroimg2"
import Navbar from "../components/Navbar"

const Contact = () => {
    return (
        <>
            <Navbar />
            <Heroimg2 heading="Contact." text="You can alway contact me" />

            <Form />
        </>
    )
}

export default Contact